const home = {
  heroTitle1: '吃瓜第一站',
  heroTitle2: '24小时不打烊',
  heroSubtitle: '每日实时追踪今日大瓜、明星塌房事件、网红反差视频及每日大赛最新动态',
  heroCta: '立即吃瓜',
  hotTopicsLabel: '今日热瓜',
  hotTopicsTitle: '大家都在吃',
  dailyCompetitionLabel: '每日大赛',
  dailyCompetitionTitle: '实时追踪',
  viewAll: '查看全部',
  featureSectionTitle: '独家深挖，不做表面文章',
  featureSectionSubtitle: '深度报道娱乐圈内幕，给你不一样的吃瓜体验',
  ctaTitle: '还没吃够？',
  ctaSubtitle: '更多精彩爆料，尽在吃瓜网',
  ctaButton: '探索更多热瓜',
  footerTagline: '吃瓜第一站 · 24小时不打烊',
  footerSubscribe: '订阅我们的 Newsletter',
  footerSubscribePlaceholder: '输入您的邮箱',
  footerSubscribeButton: '订阅',
  footerQuickLinks: '快速链接',
  footerCategories: '热门栏目',
  footerAbout: '关于我们',
  footerPrivacy: '隐私政策',
  footerTerms: '服务条款',
  copyright: '© 2026 吃瓜网 All rights reserved.',
  navHome: '首页',
  navStarScandal: '明星塌房',
  navInfluencer: '网红反差',
  navCompetition: '每日大赛',
  navAbout: '关于我们',
  views: '阅读',
  comments: '评论',
  readMore: '阅读全文',
  breadcrumbHome: '首页',
  categoryStarScandal: '明星塌房追踪',
  categoryStarScandalDesc: '最新明星塌房事件第一手报道，还原事件真相',
  categoryInfluencer: '网红反差视频',
  categoryInfluencerDesc: '探秘网红真实面目，揭露MCN行业内幕',
  categoryCompetition: '每日大赛实时',
  categoryCompetitionDesc: '每日大赛最新赛况，全程追踪精彩对决',
  categoryExclusive: '独家爆料',
  categoryExclusiveDesc: '吃瓜网独家深度报道，其他平台看不到的猛料',
  aboutPageTitle: '关于吃瓜网',
  aboutBreadcrumb: '关于我们',
  aboutHeroTag: '关于我们',
  aboutHeroTitle1: '吃瓜第一站',
  aboutHeroTitle2: '24小时不打烊',
  aboutHeroTitle3: '真实 · 快速 · 独家',
  aboutBrandTitle: '品牌介绍',
  aboutMissionTitle: '我们的使命',
  aboutTeamTitle: '我们的团队',
  aboutCredibilityTitle: '吃瓜数字',
  aboutValuesTitle: '核心价值观',
  aboutContactTitle: '联系我们',
  aboutEmailLabel: '爆料邮箱',
  aboutWechatLabel: '官方微信',
  aboutWeiboLabel: '官方微博',
  aboutAddressLabel: '公司地址',
  aboutFaqTitle: '常见问题',
};

export default home;